import { render, staticRenderFns } from "./RejectSuccessPage.vue?vue&type=template&id=12d3c14e&scoped=true&"
import script from "./RejectSuccessPage.vue?vue&type=script&lang=ts&"
export * from "./RejectSuccessPage.vue?vue&type=script&lang=ts&"
import style0 from "./RejectSuccessPage.vue?vue&type=style&index=0&id=12d3c14e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d3c14e",
  null
  
)

export default component.exports